<template>
  <project-detail-layout :tab="4">
    <div id="event-container" ref="eventContainer" class="event-container">
      <div
        class="event-container__timeline"
        @click="showPop = false"
      >
        <div class="event-container__timeline__point start_point">
          <div class="event-container__timeline__point__default_time">{{ project.start_date }}</div>
        </div>
        <div class="event-container__timeline__point end_point">
          <div class="event-container__timeline__point__default_time">{{ project.end_date }}</div>
        </div>
        <div
          v-for="(listEventInDate, date) in listKickOffBonusDates"
          :key="date"
          class="event-container__timeline__point event_point"
          :style="getPosition(date)"
          @click.stop="showPopUp(date)"
        >
          <div class="event-container__timeline__point__icon">
            <img class="kick-off-container__list_icon__image" :src="`/img/icons/events/event${listKickOffBonus[listEventInDate.list[listEventInDate.index]].type}.png`" alt=""/>
          </div>
          <div
            v-if="showPop && popupIndex === date"
            class="event-container__timeline__point__event"
            :style="getPositionEvent(listKickOffBonus[listEventInDate.list[listEventInDate.index]].date)"
          >
            <div
              v-if="listEventInDate.list.length > 1"
              class="event-container__timeline__point__event__change"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-chevron-double-left"
                viewBox="0 0 16 16"
                :class="listEventInDate.index > 0 && listEventInDate.list.length > 1 ? '' : 'disabled-text'"
                @click.stop="backEvent(date)"
              >
                <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-chevron-double-right"
                viewBox="0 0 16 16"
                :class="listEventInDate.index < listEventInDate.list.length - 1 ? '' : 'disabled-text'"
                @click.stop="nextEvent(date)"
              >
                <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
                <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </div>
            <div v-if="[0, 1, 2, 5].includes(listKickOffBonus[listEventInDate.list[listEventInDate.index]].type)">
              <div class="row">
                <div class="col-5">
                  Tiêu đề
                </div>
                <div class="col-7">
                  {{ listKickOffBonus[listEventInDate.list[listEventInDate.index]].title }}
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  Thời gian
                </div>
                <div class="col-7">
                  {{ formatDate(listKickOffBonus[listEventInDate.list[listEventInDate.index]].date) }}
                </div>
              </div>
            </div>
            <div v-else-if="listKickOffBonus[listEventInDate.list[listEventInDate.index]].type === 3">
              <div class="row">
                <div class="col-5">
                  Họ và tên
                </div>
                <div class="col-7">
                  {{ listKickOffBonus[listEventInDate.list[listEventInDate.index]].employees[0].name }}
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  Số tiền thưởng
                </div>
                <div class="col-7">
                  {{ changeFormatMoney(listKickOffBonus[listEventInDate.list[listEventInDate.index]].budget) }}
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  Ngày giải ngân
                </div>
                <div class="col-7">
                  {{ formatDate(listKickOffBonus[listEventInDate.list[listEventInDate.index]].date) }}
                </div>
              </div>
            </div>
            <div v-else-if="listKickOffBonus[listEventInDate.list[listEventInDate.index]].type === 4">
              <div class="row">
                <div class="col-5">
                  Tiêu đề
                </div>
                <div class="col-7">
                  {{ listKickOffBonus[listEventInDate.list[listEventInDate.index]].title }}
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  Thời gian
                </div>
                <div class="col-7">
                  {{ formatDate(listKickOffBonus[listEventInDate.list[listEventInDate.index]].date) }}
                </div>
              </div>
            </div>
            <div v-else-if="listKickOffBonus[listEventInDate.list[listEventInDate.index]].type === 6">
              <div class="row">
                <div class="col-5">
                  Tiêu đề
                </div>
                <div class="col-7">
                  {{ listKickOffBonus[listEventInDate.list[listEventInDate.index]].title }}
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  Thời gian
                </div>
                <div class="col-7">
                  {{ formatDate(listKickOffBonus[listEventInDate.list[listEventInDate.index]].date) }}
                </div>
              </div>
            </div>
            <div class="event-container__timeline__point__event__images">
              <div
                v-if="listKickOffBonus[listEventInDate.list[listEventInDate.index]].files.length > 0"
                class="d-flex"
                @wheel="wheelImage($event)"
              >
                <img
                  v-for="(srcItem, key) in listKickOffBonus[listEventInDate.list[listEventInDate.index]].files" :key="key"
                  class="event-container__timeline__point__event__image"
                  :src="srcItem"
                  alt="event1"
                  @click.stop="showFullImage(srcItem, key, listEventInDate.list[listEventInDate.index])"
                />
              </div>
            </div>
            <div class="event-container__timeline__point__event__notes">
              {{ listKickOffBonus[listEventInDate.list[listEventInDate.index]].note ? listKickOffBonus[listEventInDate.list[listEventInDate.index]].note : '' }}
            </div>
          </div>
          <div
            v-if="showPop && popupIndex === date"
            class="event-container__timeline__point__arrow_dow"></div>
        </div>
      </div>
    </div>
    <div class="kick-off-container">
      <div class="header">
        <div class="kick-off-container__list_icon"></div>
        <button class="header-button" @click="openModal()">
          {{ $t("project_management.kickoff.kickoff_button_text") }}
        </button>
        <div class="kick-off-container__list_icon row  align-items-center">
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event0.png" alt="event1"/>
            MTG: Kick off
          </div>
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event4.png" alt="event5"/>
            Thưởng dự án
          </div>
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event1.png" alt="event2"/>
            Party: Kick off
          </div>
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event5.png" alt="event6"/>
            MTG: close dự án
          </div>
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event2.png" alt="event3"/>
            Team building
          </div>
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event6.png" alt="event7"/>
            Other
          </div>
          <div class="col-6">
            <img class="kick-off-container__list_icon__image" src="/img/icons/events/event3.png" alt="event4"/>
            Thưởng nóng
          </div>
        </div>
      </div>
    </div>
    <CreateActivityModal :listMemberData="listMemberData"/>
    <div
      v-show="srcImgFull === '' ? '' : 'd-none'"
      class="image__show"
      @click="stopShowImageFullSize()"

    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-arrow-left-circle-fill"
        viewBox="0 0 16 16"
        @click.stop="backPic()"
        v-show="keyImg !== 0"
      >
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
      </svg>
      <img id="fullSizeImage" :src="srcImgFull" alt="Image" />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-arrow-right-circle-fill"
        viewBox="0 0 16 16"
        @click.stop="nextPic()"
        v-show="listKickOffBonus.length > 0 && keyImg !== listKickOffBonus[indexEvent].files.length - 1"
      >
        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-x-circle-fill"
        viewBox="0 0 16 16"
        @click.stop="stopShowImageFullSize()"
      >
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
      </svg>
    </div>
  </project-detail-layout>
</template>

<script>
import ProjectDetailLayout from "../ProjectDetailLayout.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import CreateActivityModal from "./CreateActivityModal";

export default {
  name: "KickOffAndBonusList",
  components: {
    CreateActivityModal,
    ProjectDetailLayout
  },
  computed: {
    ...mapGetters({
      project: "project/project",
      projectLifeTime: "project/projectLifeTime",
      listKickOffBonus: "project/listKickOffBonus",
      listKickOffBonusDates: "project/listKickOffBonusDates",
      kickOffBonusInfo: "project/kickOffBonusInfo",
      listProjectMember: "project/listProjectMember",
    }),

    listMember() {
      return this.listProjectMember;
    },
    typeList() {
      return [this.$t("project_management.kickoff.kickoff_text"),
        this.$t("project_management.kickoff.project_bonus_text"),
        this.$t("project_management.kickoff.hot_bonus_text")]
    },
    listMemberArr() {
      return this.listMember
    }
  },
  data() {
    return {
      showList: [],
      showListType: false,
      showPop: false,
      popupIndex: 0,
      listMemberData: [],
      error: [],
      srcImgFull: '',
      keyImg: 0,
      indexEvent: 0
    }
  },
  async created() {
    this.setLoading(true);
    if (Object.keys(this.project).length < 1) {
      await this.$store.dispatch("project/showDetail", this.$route.params.id)
    }
    await this.$store.dispatch('project/getListKickOffBonus', this.$route.params.id);
    this.setLoading(false);
  },
  mounted: function () {
    // add an event listener for keypress
    window.addEventListener('keydown', this.handleKeyPress)
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    toggleContent(key) {
      if (this.showList.includes(key)) {
        let index = this.showList.indexOf(key);
        this.showList.splice(index, 1)
      } else {
        this.showList.push(key)
      }
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    async openModal() {
      this.setLoading(true);
      await this.$store.dispatch('project/getListProjectMember', this.$route.params.id);
      this.listMemberData = this.listMember;
      await this.$bvModal.show('bv-modal-choose-type');
      this.setLoading(false);
    },
    getPosition(date) {
      const div = this.$refs['eventContainer'];
      if (div
        && this.listKickOffBonusDates[date]
        && this.listKickOffBonusDates[date].distant >= 0
        && this.listKickOffBonusDates[date].distant <= this.projectLifeTime) {
        const divLength = div.offsetWidth - 15;
        const length = this.listKickOffBonusDates[date].distant * divLength / this.projectLifeTime;
        return {
          left: length + 'px'
        }
      } else {
        return {
          display: 'none'
        }
      }
    },
    getPositionEvent(date) {
      const dateC = moment(date, "YYYY-MM-DD hh:mm:ss");
      const startDate = moment(this.project.start_date, "DD/MM/YYYY");
      const distantDateWithStart = dateC.diff(startDate, 'days');
      const div = document.getElementById("event-container");
      if (div) {
        const divLength = div.offsetWidth;
        const length = distantDateWithStart * divLength / this.projectLifeTime;
        const lengthRemain = divLength - length;
        if (lengthRemain < 115) {
          return {
            left: '-280px'
          }
        } else if (length < 115) {
          return {
            left: '-50px'
          }
        } else {
          return {
            left: '-165px'
          }
        }
      } else {
        return {
          left: '-165px'
        }
      }
    },
    showPopUp(index) {
      this.showPop = this.popupIndex !== index || !this.showPop;
      this.popupIndex = index
    },
    showFullImage(src, key, index) {
      this.srcImgFull = src;
      this.keyImg = key;
      this.indexEvent = index;
    },
    stopShowImageFullSize() {
      this.srcImgFull = '';
    },
    changeFormatMoney(n) {
      if (!n) {
        return '0 vnđ';
      }

      return `${n}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
    },
    wheelImage(e) {
      const imgDiv = e.target.parentElement.parentElement;
      if (e.deltaY > 0) {
        imgDiv.scrollLeft += 10;
      } else if (e.deltaY < 0) {
        imgDiv.scrollLeft -= 10;
      }
    },
    backPic() {
      if (this.keyImg !== 0) {
        this.srcImgFull = this.listKickOffBonus[this.indexEvent].files[this.keyImg - 1];
        this.keyImg = this.keyImg - 1;
      }
    },
    nextPic() {
      if (this.keyImg !== this.listKickOffBonus[this.indexEvent].files.length - 1) {
        this.srcImgFull = this.listKickOffBonus[this.indexEvent].files[this.keyImg + 1];
        this.keyImg = this.keyImg + 1;
      }
    },
    backEvent(date) {
      if (this.listKickOffBonusDates[date].index > 0 && this.listKickOffBonusDates[date].list.length > 1) {
        this.listKickOffBonusDates[date].index--;
      }
    },
    nextEvent(date) {
      if (this.listKickOffBonusDates[date].index < this.listKickOffBonusDates[date].list.length - 1) {
        this.listKickOffBonusDates[date].index++;
      }
    },
    handleKeyPress: function (e) {
      const keyCode = String(e.keyCode || e.code || e.keyIdentifier);
      if (this.srcImgFull !== '') {
        if (keyCode === '27') {
          this.stopShowImageFullSize();
        }
        if (keyCode === '37') {
          this.backPic();
        }

        if (keyCode === '39') {
          this.nextPic();
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  margin-bottom: 10px;
}

.event-container {
  margin: 0 60px 30px 60px;
  &__timeline {
    height: 330px;
    border-bottom: solid #3488EB 4px;
    position: relative;
    &__point {
      position: absolute;
      bottom: -10px;
      width: 15px;
      height: 15px;
      background-color: #FFFFFF;
      border-radius: 50%;
      border: solid #3488EB 4px;

      &.start_point {
        z-index: 1;
      }
      &.end_point {
        right: 0;
        z-index: 1;
      }

      &__default_time {
        height: 30px;
        position: absolute;
        bottom: -35px;
        left: -30px;
        color: #303C54;
      }

      &.event_point {
        position: absolute;
        left: 80px;
        z-index: 2;
      }
      &__event {
        font-family: "Helvetica Neue", sans-serif;
        position: absolute;
        bottom: 55px;
        //left: -165px;
        width: 330px;
        height: 280px;
        background-color: #FFFFFF;
        border-radius: 10px;
        box-shadow: 0 0 25px -10px grey;
        padding: 14px;
        &__change {
          width: 302px;
          height: 24px;
        }
        &__images{
          margin: 14px 0;
          height: 95px;
          width: 302px;
          overflow: auto;
        }
        &__images::-webkit-scrollbar {
          -webkit-appearance: none;
          height: 4px;
        }
        &__images::-webkit-scrollbar-thumb {
          border-radius: 4px;
          background-color: rgba(0,0,0,.5);
          -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
        }
        &__image{
          height: 90px;
          width: 90px;
          border-radius: 10px;
          margin-right: 2px;
        }
        &__notes{
          overflow: auto;
          height: 31%;
          word-wrap: break-word;
        }
        .col-5 {
          font-weight: 400;
          color: #7D828B;
        }
        .col-7 {
          font-weight: 700;
          color: #303C54;
          display: flex;
          justify-content: end;
        }
        .bi {
          position: absolute;
          width: 20px;
          height: 20px;
        }
        .bi-chevron-double-left {
          left: 130px;
        }
        .bi-chevron-double-right {
          right: 130px;
        }
        .disabled-text {
          color: #7D828B;
        }
      }

      &__icon {
        position: absolute;
        bottom: 15px;
        left: -9px;
        width: 24px;
        height: 23px;
      }

      &__arrow_dow {
        position: absolute;
        bottom: 35px;
        left: -15px;
        width: 30px;
        height: 20px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid #FFFFFF;
      }
    }
 }
}
.kick-off-container {
  padding: 0 30px;
  &__list_icon{
    padding: 10px 0;
    height: 155px;
    width: 360px;
    font-weight: 400;
    color: #303C54;
    &__image{
      width: 24px;
      height: 23px;
      margin-right: 5px;
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-text {
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}

.header-button {
  width: 172px;
  height: 49px;
  background: #118FA6;
  border-radius: 5px;
  border-width: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #EBF3F4;
  outline: none;
  font-family: 'Helvetica Neue', sans-serif;
}

.kick-off-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  background: #EDEDED;
  padding: 13px 21px 13px 24px;
}

.kick-off-item-header-text {
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #303C54;
}

.header-icon {
  display: flex;
}

.kick-off-bonus-item-content {
  padding: 20px 24px
}

.total-amount-heading {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
}

.total-amount-number {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding: 12px 0 12px 14px;
  background: #FFFFFF;
  border: 1px solid #CFCFCF;
  border-radius: 5px;
  width: 100%
}

.employee-component {
  display: flex;
  justify-content: space-between;
}

.employee-info {
  flex: 2
}

.bonus-info {
  flex: 1;
  margin-left: 24px;
}

.employee-bonus-heading {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding-top: 20px
}

.employee-name {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding: 12px 0 12px 14px;
  background: #FFFFFF;
  border: 1px solid #CFCFCF;
  border-radius: 5px;
}

.hot-bonus-heading {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
}

.employee-bonus {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding: 12px 0 12px 14px;
  background: #FFFFFF;
  border: 1px solid #CFCFCF;
  border-radius: 5px;
}
.image__show {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,.3);
  img {
    width: fit-content;
  }
  .bi {
    width: 70px;
    height: 70px;
  }
  .bi-arrow-left-circle-fill {
    position: fixed;
    left: 0;
  }
  .bi-arrow-right-circle-fill {
    position: fixed;
    right: 0;
  }
  .bi-x-circle-fill {
    position: fixed;
    right: 0;
    top: 0;
  }
}
</style>
